/**
 * @generated SignedSource<<f120000950986da8bd4e58dae842c17c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Branch = "adviceAndConsulting" | "analysisAndStatistic" | "financeAccountingAndControlling" | "graphicsAndDesign" | "healthMedicineAndSocialAffairs" | "itAndSoftwareDevelopment" | "legalServices" | "marketingAndAdvertising" | "otherFieldsOfActivity" | "personnelAndHr" | "processPlanningAndQualityAssurance" | "productManagement";
export type TeamSize = "fiftyToHundred" | "oneToTen" | "overHundred" | "tenToTwentyFive" | "twentyFiveToFifty";
import { FragmentRefs } from "relay-runtime";
export type editUserForm_UserFragment$data = {
  readonly activated: boolean;
  readonly email: string;
  readonly extension: {
    readonly adsOptIn?: boolean;
    readonly avatar?: {
      readonly id: string;
      readonly name: string;
      readonly url: string | null;
    } | null;
    readonly branch?: Branch | null;
    readonly firstName?: string;
    readonly lastName?: string;
    readonly position?: string | null;
    readonly teamSize?: TeamSize | null;
  } | null;
  readonly groupAssociations: ReadonlyArray<{
    readonly account: {
      readonly name: string;
    } | null;
    readonly group: {
      readonly id: string;
      readonly name: string;
    } | null;
  }>;
  readonly id: string;
  readonly isDeleted: boolean;
  readonly name: string;
  readonly registeredAt: string;
  readonly " $fragmentType": "editUserForm_UserFragment";
};
export type editUserForm_UserFragment$key = {
  readonly " $data"?: editUserForm_UserFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"editUserForm_UserFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "editUserForm_UserFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "registeredAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDeleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserGroupAssociation",
      "kind": "LinkedField",
      "name": "groupAssociations",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Account",
          "kind": "LinkedField",
          "name": "account",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserInAccountGroup",
          "kind": "LinkedField",
          "name": "group",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "userExtensionKind",
          "value": "Academies"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "extension",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "adsOptIn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "branch",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "teamSize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "position",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "File",
              "kind": "LinkedField",
              "name": "avatar",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "AcademiesUserExtension",
          "abstractKey": null
        }
      ],
      "storageKey": "extension(userExtensionKind:\"Academies\")"
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "4aeea6079e9d733b408bdfb959a1b411";

export default node;
